import PropTypes from 'prop-types';
import React from 'react';
import Box from '@mui/material/Box';

const HeaderWithActions = ({ title, actions }) => (
  <Box className="header-with-actions" display="flex" alignItems="center" justifyContent="space-between">
    <div className="header-title">{title}</div>
    <div className="header-actions">{actions}</div>
  </Box>
);

HeaderWithActions.propTypes = {
  title: PropTypes.node,
  actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.object]),
};

export default HeaderWithActions;
